import React from 'react'

import { deepCopy } from '../helper/deepCopy'

const UnreadMessagesContext = React.createContext({
  unreadMessagesList: [],
  handleAddUnreadMessages: undefined,
  handleDeleteUnreadMessages: undefined,
  handleClearUnreadMessages: undefined,
  isWidgetPopup: false,
})

const UnreadMessagesProvider = ({ children }) => {
  const [unreadMessagesList, setUnreadMessagesList] = React.useState([])

  const handleAddUnreadMessages = newUnreadMessage => {
    const unreadMessagesListCopy = deepCopy(unreadMessagesList)
    unreadMessagesListCopy.push(newUnreadMessage)
    const lastTwoElem = unreadMessagesListCopy.slice(
      unreadMessagesListCopy.length - 5,
      unreadMessagesListCopy.length,
    )
    setUnreadMessagesList(lastTwoElem)
  }

  const handleDeleteUnreadMessages = deleteId => {
    const updatedUnreadMessagesList = unreadMessagesList.filter(
      ({ id }) => id !== deleteId,
    )
    setUnreadMessagesList(updatedUnreadMessagesList)
  }

  const handleClearUnreadMessages = () => {
    setUnreadMessagesList([])
  }

  const getIsWidgetPopup = () => {
    return unreadMessagesList.some(message => message.isWidgetPopup)
  }

  return (
    <UnreadMessagesContext.Provider
      value={{
        isWidgetPopup: getIsWidgetPopup(),
        unreadMessagesList,
        handleClearUnreadMessages,
        handleAddUnreadMessages,
        handleDeleteUnreadMessages,
      }}>
      {children}
    </UnreadMessagesContext.Provider>
  )
}

export { UnreadMessagesProvider, UnreadMessagesContext }
